import React from 'react';
import noImagePng from '../images/no_image.png';

const imageModules = import.meta.glob('../images/*', {
  eager: true,
  import: 'default',
});

const CustomImage = ({ src, style, className, alt }) => {
  const image_path = imageModules[`../images/${src}`] || noImagePng;
  return <img style={style} src={image_path} className={className} alt={alt} />;
};

export default CustomImage;
